import { UserFromClient, UserFromDb } from "shared/src/DatabaseObjects/DatabaseObjects"

export function getUserRole(user: UserFromClient | UserFromDb): string {
	return ((user as UserFromClient)?.user_role || (user as UserFromDb)?.userRole) === "brandEditor"
		? "brand editor"
		: ((user as UserFromClient)?.user_role ?? (user as UserFromDb)?.userRole ?? "recruiter")
}
